// SPDX-License-Identifier: AGPL-3.0-or-later

import {getPremiumProductName} from '@app/features/premium/utils/PremiumUtils';
import {msg} from '@lingui/core/macro';

export const COLORS_DESCRIPTOR = msg({
	message: 'Colors',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const FONTS_DESCRIPTOR = msg({
	message: 'Fonts',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const COLOR_DESCRIPTOR = msg({
	message: 'Color',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const SIDEBAR_2_DESCRIPTOR = msg({
	message: 'Sidebar',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TYPING_DESCRIPTOR = msg({
	message: 'Typing',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const INDICATOR_DESCRIPTOR = msg({
	message: 'Indicator',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const KEYBOARD_HINTS_DESCRIPTOR = msg({
	message: 'Keyboard hints',
	comment: 'Toggle label and settings search entry for controlling tooltip keyboard shortcut hints.',
});
export const SHOW_NEKO_DESCRIPTOR = msg({
	message: 'Show Neko',
	comment: 'Toggle label and settings search entry for showing the Neko sprite that chases the cursor.',
});
export const USE_FLUXER_SANS_ON_WINDOWS_DESCRIPTOR = msg({
	message: 'Use Fluxer Sans on Windows',
	comment:
		'Toggle label and settings search entry for showing app text in the Fluxer Sans font instead of the Windows system font. Fluxer Sans is a font name and must not be translated.',
});
export const KEEP_NEKO_STILL_DESCRIPTOR = msg({
	message: 'Keep Neko still',
	comment: 'Toggle label and settings search entry for stopping the Neko sprite from chasing the cursor.',
});
export const ENABLE_FAVORITES_DESCRIPTOR = msg({
	message: 'Enable favorites',
	comment: 'Toggle label and settings search entry for controlling whether favorites are visible throughout the app.',
});
export const SHOW_HELP_CENTER_BUTTON_DESCRIPTOR = msg({
	message: 'Show help center button',
	comment: 'Toggle label and settings search entry for showing the help center button in the sidebar.',
});
export const NEKO_DESCRIPTOR = msg({
	message: 'Neko',
	comment: 'Settings search synonym. Proper name of the optional cat sprite that chases the cursor.',
});
export const CHAT_INPUT_DESCRIPTOR = msg({
	message: 'chat input',
	comment: 'Settings search synonym. Refers to the message composer area.',
});
export const MUTED_CHANNELS_DESCRIPTOR = msg({
	message: 'Muted channels',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MUTED_DESCRIPTOR = msg({
	message: 'Muted',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const UNREAD_DESCRIPTOR = msg({
	message: 'Unread',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DIRECT_MESSAGE_DESCRIPTOR = msg({
	message: 'Direct message',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DIM_STRIKETHROUGH_TEXT_DESCRIPTOR = msg({
	message: 'Dim strikethrough text',
	comment: 'Toggle label and settings search entry for slightly muting text formatted with Markdown strikethrough.',
});
export const SHOW_STRIKETHROUGH_MARKDOWN_TEXT_IN_A_SLIGHTLY_MUTED_COLOR_DESCRIPTOR = msg({
	message: 'Show strikethrough Markdown text in a slightly muted color.',
	comment:
		'Description for a visual accessibility setting that mutes the color of text formatted with Markdown strikethrough.',
});
export const STRIKETHROUGH_DESCRIPTOR = msg({
	message: 'Strikethrough',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const STRIKE_THROUGH_DESCRIPTOR = msg({
	message: 'Strike through',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DELETED_TEXT_DESCRIPTOR = msg({
	message: 'Deleted text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const GRAY_TEXT_DESCRIPTOR = msg({
	message: 'Gray text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MARKDOWN_DESCRIPTOR = msg({
	message: 'Markdown',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const READ_MESSAGES_DESCRIPTOR = msg({
	message: 'Read messages',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const READ_ALOUD_DESCRIPTOR = msg({
	message: 'Read aloud',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TTS_DESCRIPTOR = msg({
	message: 'TTS',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TEXT_TO_SPEECH_3_DESCRIPTOR = msg({
	message: 'Text-to-speech',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const SPEECH_DESCRIPTOR = msg({
	message: 'Speech',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const NARRATION_DESCRIPTOR = msg({
	message: 'Narration',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CALL_DESCRIPTOR = msg({
	message: 'Call',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CONTEXT_MENU_DESCRIPTOR = msg({
	message: 'Context menu',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const GIF_DESCRIPTOR = msg({
	message: 'GIF',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const EMOJI_DESCRIPTOR = msg({
	message: 'Emoji',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MENTIONS_DESCRIPTOR = msg({
	message: 'Mentions',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const AUDIO_2_DESCRIPTOR = msg({
	message: 'Audio',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const PREMIUM_PRODUCT_NAME_KEYWORD = getPremiumProductName;
export const DM_DESCRIPTOR = msg({
	message: 'DM',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const PING_DESCRIPTOR = msg({
	message: 'Ping',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const POPUP_DESCRIPTOR = msg({
	message: 'Popup',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CALL_CONFIRMATION_DESCRIPTOR = msg({
	message: 'Call confirmation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CONFIRM_CALLS_DESCRIPTOR = msg({
	message: 'Confirm calls',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const START_CALL_DESCRIPTOR = msg({
	message: 'Start call',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const VIDEO_CALL_DESCRIPTOR = msg({
	message: 'Video call',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const RING_DESCRIPTOR = msg({
	message: 'Ring',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const UNDERLINE_DESCRIPTOR = msg({
	message: 'Underline',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const UNDERLINE_LINKS_DESCRIPTOR = msg({
	message: 'Underline links',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const LINK_UNDERLINE_DESCRIPTOR = msg({
	message: 'Link underline',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TEXT_SELECTION_DESCRIPTOR = msg({
	message: 'Text selection',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SELECT_TEXT_DESCRIPTOR = msg({
	message: 'Select text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const COPY_TEXT_DESCRIPTOR = msg({
	message: 'Copy text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MESSAGE_PREVIEW_DESCRIPTOR = msg({
	message: 'Message preview',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MESSAGE_PREVIEWS_DESCRIPTOR = msg({
	message: 'Message previews',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const INBOX_PREVIEW_DESCRIPTOR = msg({
	message: 'Inbox preview',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const LIVE_REGION_DESCRIPTOR = msg({
	message: 'Live region',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ESCAPE_DESCRIPTOR = msg({
	message: 'Escape',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ESCAPE_KEY_DESCRIPTOR = msg({
	message: 'Escape key',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const KEYBOARD_MODE_DESCRIPTOR = msg({
	message: 'Keyboard mode',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CONTEXT_MENU_SHORTCUTS_DESCRIPTOR = msg({
	message: 'Context menu keybinds',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const RIGHT_CLICK_MENU_DESCRIPTOR = msg({
	message: 'Right-click menu',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const FOCUS_RING_DESCRIPTOR = msg({
	message: 'Focus ring',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TEXTAREA_DESCRIPTOR = msg({
	message: 'Text area',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TEXTAREA_FOCUS_RING_DESCRIPTOR = msg({
	message: 'Text area focus ring',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MESSAGE_INPUT_DESCRIPTOR = msg({
	message: 'Message input',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SYNC_MOTION_DESCRIPTOR = msg({
	message: 'Sync motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SYNC_REDUCED_MOTION_DESCRIPTOR = msg({
	message: 'Sync reduced motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SYSTEM_REDUCED_MOTION_DESCRIPTOR = msg({
	message: 'System reduced motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SYSTEM_MOTION_DESCRIPTOR = msg({
	message: 'System motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PREFERS_REDUCED_MOTION_DESCRIPTOR = msg({
	message: 'Prefers reduced motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ANIMATIONS_DESCRIPTOR = msg({
	message: 'Animations',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTOSCROLLING_DESCRIPTOR = msg({
	message: 'Autoscrolling',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MIDDLE_CLICK_SCROLLING_DESCRIPTOR = msg({
	message: 'Middle-click scrolling',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SCROLL_ANIMATION_DESCRIPTOR = msg({
	message: 'Scroll animation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SCROLLING_DESCRIPTOR = msg({
	message: 'Scrolling',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TOOLTIPS_DESCRIPTOR = msg({
	message: 'Tooltips',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MAIL_DESCRIPTOR = msg({
	message: 'Mail',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ADDRESS_DESCRIPTOR = msg({
	message: 'Address',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CONTACT_DESCRIPTOR = msg({
	message: 'Contact',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CREDENTIALS_DESCRIPTOR = msg({
	message: 'Credentials',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CHANGE_PASSWORD_DESCRIPTOR = msg({
	message: 'Change password',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TWO_FACTOR_DESCRIPTOR = msg({
	message: 'Two-factor',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTHENTICATION_DESCRIPTOR = msg({
	message: 'Authentication',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTHENTICATOR_DESCRIPTOR = msg({
	message: 'Authenticator',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const BACKUP_CODES_DESCRIPTOR = msg({
	message: 'Backup codes',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const RECOVERY_DESCRIPTOR = msg({
	message: 'Recovery',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PASSKEYS_DESCRIPTOR = msg({
	message: 'Passkeys',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PASSKEY_DESCRIPTOR = msg({
	message: 'Passkey',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PASSWORDLESS_DESCRIPTOR = msg({
	message: 'Passwordless',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const BIOMETRIC_DESCRIPTOR = msg({
	message: 'Biometric',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const BIOMETRICS_DESCRIPTOR = msg({
	message: 'Biometrics',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const FINGERPRINT_DESCRIPTOR = msg({
	message: 'Fingerprint',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SECURITY_KEY_DESCRIPTOR = msg({
	message: 'Security key',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TWO_FA_DESCRIPTOR = msg({
	message: '2FA',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CLOSE_ACCOUNT_DESCRIPTOR = msg({
	message: 'Close account',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const VOICE_CHANNEL_CONFIRMATION_DESCRIPTOR = msg({
	message: 'Voice channel confirmation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CONFIRM_VOICE_JOIN_DESCRIPTOR = msg({
	message: 'Confirm voice join',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TWO_CLICKS_DESCRIPTOR = msg({
	message: 'Two clicks',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SHORTCUT_BADGES_DESCRIPTOR = msg({
	message: 'Keybind badges',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const USERS_DESCRIPTOR = msg({
	message: 'Users',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const EXPRESSION_AUTOCOMPLETE_DESCRIPTOR = msg({
	message: 'Expression autocomplete',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const COLON_AUTOCOMPLETE_DESCRIPTOR = msg({
	message: 'Colon autocomplete',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const EMOTICONS_DESCRIPTOR = msg({
	message: 'Emoticons',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TEXT_REPLACEMENT_DESCRIPTOR = msg({
	message: 'Text replacement',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MESSAGE_INPUT_BUTTONS_DESCRIPTOR = msg({
	message: 'Message input buttons',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const COMPOSER_BUTTONS_DESCRIPTOR = msg({
	message: 'Composer buttons',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SEND_BUTTON_DESCRIPTOR = msg({
	message: 'Send button',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SCROLL_TO_BOTTOM_DESCRIPTOR = msg({
	message: 'Scroll to bottom',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SENT_MESSAGES_DESCRIPTOR = msg({
	message: 'Sent messages',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DEVELOPER_MODE_DESCRIPTOR = msg({
	message: 'Developer mode',
	comment: 'Settings search entry label. Also used as a search synonym in the settings search bar.',
});

export const DESKTOP_WINDOW_DESCRIPTOR = msg({
	message: 'Desktop window',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SIZE_DESCRIPTOR = msg({
	message: 'Size',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TITLE_BAR_DESCRIPTOR = msg({
	message: 'Title bar',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MINIMIZE_DESCRIPTOR = msg({
	message: 'Minimize',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const LINKED_DEVICES_DESCRIPTOR = msg({
	message: 'Linked devices',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const REDEEM_A_GIFT_DESCRIPTOR = msg({
	message: 'Redeem a gift',
	comment: 'Settings search entry label. Names the settings search entry in the settings UI.',
});

export const PURCHASED_GIFTS_DESCRIPTOR = msg({
	message: 'Purchased gifts',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const KEYBOARD_SHORTCUTS_DESCRIPTOR = msg({
	message: 'Keyboard shortcuts',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SHORTCUT_DESCRIPTOR = msg({
	message: 'Shortcut',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PUSH_TO_TALK_DESCRIPTOR = msg({
	message: 'Push to talk',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TIME_FORMAT_DESCRIPTOR = msg({
	message: 'Time format',
	comment: 'Settings search entry label. Also used as a search synonym in the settings search bar.',
});

export const TIME_DESCRIPTOR = msg({
	message: 'Time',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SPELL_CHECK_DESCRIPTOR = msg({
	message: 'Spellcheck',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CONNECTIONS_DESCRIPTOR = msg({
	message: 'Connections',
	comment: 'Settings search entry label. Also used as a search synonym in the settings search bar.',
});

export const BIO_DESCRIPTOR = msg({
	message: 'Bio',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const UNREAD_BADGE_DESCRIPTOR = msg({
	message: 'Unread badge',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const UNREAD_MESSAGE_BADGE_DESCRIPTOR = msg({
	message: 'Unread message badge',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MESSAGE_BADGE_DESCRIPTOR = msg({
	message: 'Message badge',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DOCK_BADGE_DESCRIPTOR = msg({
	message: 'Dock badge',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const TASKBAR_BADGE_DESCRIPTOR = msg({
	message: 'Taskbar badge',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const OUTPUT_VOLUME_DESCRIPTOR = msg({
	message: 'Output volume',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SOUND_VOLUME_DESCRIPTOR = msg({
	message: 'Sound volume',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const BACKGROUND_DESCRIPTOR = msg({
	message: 'Background',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const LOGIN_DESCRIPTOR = msg({
	message: 'Login',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CODES_DESCRIPTOR = msg({
	message: 'Codes',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const INBOX_DESCRIPTOR = msg({
	message: 'Inbox',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTHORIZATION_DESCRIPTOR = msg({
	message: 'Authorization',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTOPLAY_DESCRIPTOR = msg({
	message: 'Autoplay',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const STREAMING_DESCRIPTOR = msg({
	message: 'Screen sharing',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DOUBLE_CLICK_DESCRIPTOR = msg({
	message: 'Double-click',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const VOICE_ACTIVITY_DESCRIPTOR = msg({
	message: 'Voice activity',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const EXPRESSIONS_DESCRIPTOR = msg({
	message: 'Expressions',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const INTEGRATIONS_DESCRIPTOR = msg({
	message: 'Integrations',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const BLOCKED_USERS_DESCRIPTOR = msg({
	message: 'Blocked users',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DEVICES_DESCRIPTOR = msg({
	message: 'Devices',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ACCESSIBILITY_DESCRIPTOR = msg({
	message: 'Accessibility',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const APPLICATIONS_DESCRIPTOR = msg({
	message: 'Applications',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DESKTOP_SETTINGS_FALLBACK_DESCRIPTOR = msg({
	message: 'Desktop app',
	comment:
		'User settings tab label shown on desktop builds when the OS could not be identified (fallback for the per-OS labels).',
});

export const ACCOUNT_DESCRIPTOR = msg({
	message: 'Account',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PRIVACY_DESCRIPTOR = msg({
	message: 'Privacy',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const AUTHORIZED_APPS_DESCRIPTOR = msg({
	message: 'Authorized apps',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const KEYBINDS_DESCRIPTOR = msg({
	message: 'Keybinds',
	comment:
		'Name of the settings tab where people set keyboard keys for actions. Also used as a settings search synonym.',
});

export const KEYBIND_DESCRIPTOR = msg({
	message: 'Keybind',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SHORTCUTS_DESCRIPTOR = msg({
	message: 'Shortcuts',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const LANGUAGE_DESCRIPTOR = msg({
	message: 'Language',
	comment: 'Settings search entry label. Also used as a search synonym in the settings search bar.',
});

export const EMBED_DEBUGGER_DESCRIPTOR = msg({
	message: 'Embed debugger',
	comment: 'Developer settings tab for testing URL unfurls and rendered embeds.',
});

export const ENABLE_TEXT_SELECTION_DESCRIPTOR = msg({
	message: 'Enable text selection',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const VIDEO_DESCRIPTOR = msg({
	message: 'Video',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MOTION_DESCRIPTOR = msg({
	message: 'Motion',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SMOOTH_SCROLLING_DESCRIPTOR = msg({
	message: 'Smooth scrolling',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SECURITY_DESCRIPTOR = msg({
	message: 'Security',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const DELETE_DESCRIPTOR = msg({
	message: 'Delete',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const REMOVE_DESCRIPTOR = msg({
	message: 'Remove',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const JOIN_VOICE_DESCRIPTOR = msg({
	message: 'Join voice',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ANIMATION_DESCRIPTOR = msg({
	message: 'Animation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const KEYBOARD_2_DESCRIPTOR = msg({
	message: 'Keyboard',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const PRONOUNS_DESCRIPTOR = msg({
	message: 'Pronouns',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const MASTER_VOLUME_DESCRIPTOR = msg({
	message: 'Master volume',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const VOLUME_DESCRIPTOR = msg({
	message: 'Volume',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const ACTIVE_NOW_DESCRIPTOR = msg({
	message: 'Active now',
	comment: 'Status label indicating a user is currently active.',
});

export const MESSAGES_3_DESCRIPTOR = msg({
	message: 'Messages',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const CHANNEL_LIST_DESCRIPTOR = msg({
	message: 'Channel list',
	comment: 'Settings section label. Also used as a search synonym in the settings search bar.',
});

export const NAVIGATION_DESCRIPTOR = msg({
	message: 'Navigation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const SHOW_DOWNLOAD_BUTTON_DESCRIPTOR = msg({
	message: 'Show download button',
	comment: 'Toggle label and settings search entry for showing the download app button in the sidebar.',
});

export const VOICE_DESCRIPTOR = msg({
	message: 'Voice',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});

export const FRIENDS_DESCRIPTOR = msg({
	message: 'Friends',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
